import { render } from "./JobOpeningPage.vue?vue&type=template&id=08e04e10"
import script from "./JobOpeningPage.vue?vue&type=script&lang=js"
export * from "./JobOpeningPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__